<template>
    <v-dialog v-bind="$attrs" max-width="500px" v-on="$listeners">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <DateTextfield v-model="publishFromInput" :label="$t('pub_from')" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <DateTextfield v-model="publishToInput" :label="$t('pub_to')" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="$emit('cancel')">{{ $t('cancel') }}</v-btn>
                <v-btn color="action" text :loading="loading" @click="onPublish">{{ $t('save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'MagazinPublishDlg',
    props: {
        title: String,
        publishFrom: dayjs,
        publishTo: dayjs,
        loading: Boolean,
    },
    data() {
        return {
            publishFromInput: this.publishFrom,
            publishToInput: this.publishTo,
        };
    },

    watch: {
        publishFrom() {
            this.publishFromInput = this.publishFrom;
        },
        publishTo() {
            this.publishToInput = this.publishTo;
        },
    },

    methods: {
        onPublish() {
            this.$emit('publish', { publishFrom: this.publishFromInput, publishTo: this.publishToInput });
        },
    },
};
</script>
